(function() { module.exports = window["wc"]["wcBlocksSharedHocs"]; }());